import { SvgIcon } from "@mui/material";
import React from "react";

function MatxSvg(props) {
  return (
    <SvgIcon
      component={props.component}
      preserveAspectRatio="none"
      width="100%"
      height="100%"
      style={{
        height: "inherit",
        width: "inherit",
      }}
      {...props}
    />
  );
}

export default MatxSvg;
